// ============================================================================
// MINIMAX - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'minimax',
  name: 'Minimax',
  category: 'Game Theory',
  complexity: {
    time: 'O(b^d)',
    space: 'O(d)'
  },
  description: 'A recursive algorithm for decision-making in two-player zero-sum games. It explores the game tree to the specified depth, assuming the opponent plays optimally, and selects the move that minimizes the maximum possible loss.'
};
